export enum ModalType {
    //ingen type valgt: default slidein
    originalModal = "modal-original",
}
